const req = require.context(
  '.',
  false,
  /^\.\/(?!index\.js$)(?!.*\.(test|spec)\.js$).*\.js$/,
);

req.keys().forEach(key => {
  const hooksName = key.replace(/^\.\/([^.]+)\.js$/, '$1');
  module.exports[hooksName] = req(key).default;
});
